module.exports = __webpack_public_path__ + "img/slika5_2022.c0c383a4.png";